// Convierte de YYYYMMDD (SAP) a YYYY-MM-DD (HTML)
export function ctohtml(sapDate) {
  if (!sapDate || sapDate.length !== 8) return "";
  const year = sapDate.slice(0, 4);
  const month = sapDate.slice(4, 6);
  const day = sapDate.slice(6, 8);
  return `${year}-${month}-${day}`;
}

// Convierte de YYYY-MM-DD (HTML) a YYYYMMDD (SAP)
export function htmltoc(htmlDate) {
  if (!htmlDate) return "";
  return htmlDate.replace(/-/g, "");
}

// Convierte de YYYYMMDD o YYYY-MM-DD a DD/MM/YYYY
export function ctod(date) {
  if (!date) return "";
  let y, m, d;

  if (date.includes("-")) {
    // Formato HTML
    [y, m, d] = date.split("-");
  } else if (date.length === 8 && date > "00000000") {
    // Formato SAP
    y = date.slice(0, 4);
    m = date.slice(4, 6);
    d = date.slice(6, 8);
  } else {
    return "";
  }

  return `${d}/${m}/${y}`;
}

// Convierte de DD/MM/YYYY a YYYYMMDD (SAP)
export function dtoc(date) {
  if (!date) return "";
  const parts = date.split("/");
  if (parts.length !== 3) return "";
  const [d, m, y] = parts;
  return `${y}${m}${d}`;
}

// Devuelve la fecha actual en formato HTML (YYYY-MM-DD)
export function getDatehtml() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Devuelve la fecha actual en formato SAP (YYYYMMDD)
export function getDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}${m}${day}`;
}

/**
 * Convierte una fecha SQL/ISO a formato legible.
 * @param {string|Array} input - Fecha en formato SQL/ISO o array de fechas [start, end]
 * @param {string} format - 'auto' | 'date' | 'datetime' | 'time'
 * @returns {string|Array} Fecha formateada o array de fechas formateadas
 */
export function formatSQLDate(input, format = "auto", segons = true) {
  const pad = (n) => String(n).padStart(2, "0");

  const formatSingle = (sqlDate) => {
    if (!sqlDate) return "";

    const d = new Date(sqlDate);
    if (isNaN(d.getTime())) return "";

    const day = pad(d.getDate());
    const month = pad(d.getMonth() + 1);
    const year = d.getFullYear();
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());
   
    let inferredFormat = format;
    if (format === "auto") {
      // Detectar automáticamente
      if (/T/.test(sqlDate) || hours + minutes + seconds !== "000000") {
        inferredFormat = "datetime";
      } else {
        inferredFormat = "date";
      }
    }
   
    switch (inferredFormat) {
      case "datetime":
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      case "time":
         if(segons) 
          return `${hours}:${minutes}:${seconds}`;
         else 
          return `${hours}:${minutes}`;

      case "date":
      default:
        return `${day}/${month}/${year}`;
    }
  };

  if (Array.isArray(input)) {
    return input.map((d) => formatSingle(d));
  }

  return formatSingle(input);
}

export function strhor(decimal, segundos = false) {
  if (decimal == null || isNaN(decimal)) return "0:00";

  const horas = Math.floor(decimal);
  const centesimas = (decimal - horas) * 100;

  // Convertimos las centésimas a minutos reales
  const minutosReales = (centesimas * 60) / 100;

  const minutos = Math.floor(minutosReales);
  const segundosCalc = Math.round((minutosReales - minutos) * 60);

  let segundosStr = "";
  if (segundos) {
    segundosStr = `:${segundosCalc.toString().padStart(2, "0")}`;
  }

  return `${horas}:${minutos.toString().padStart(2, "0")}${segundosStr}`;
}

/*

// Solo fecha
formatSQLDate("2025-08-25"); 
// "25/08/2025"

// Fecha + hora
formatSQLDate("2025-08-25T14:30:15", "datetime"); 
// "25/08/2025 14:30:15"

// Solo hora
formatSQLDate("2025-08-25T14:30:15", "time"); 
// "14:30:15"

// Auto detect
formatSQLDate("2025-08-25T00:00:00"); 
// "25/08/2025"

// Rango de fechas
formatSQLDate(["2025-08-25", "2025-08-30T12:00:00"]); 
// ["25/08/2025", "30/08/2025 12:00:00"]

*/

/**
 * Convierte un valor de fecha a formato legible para display
 * @param {any} value - Valor original
 * @param {object} field - { Type, TypeEdit }
 * @returns {string} Fecha en formato DD/MM/YYYY
 */
export function displayDate(value, field) {
  if (!value) return "";
  const { TYPE, TYPEEDIT } = field;

  //if (TYPE !== 2 && TYPE !== 13) return value; // solo campos de edición de fecha

 

  if (TYPE === 2) { // fecha datetime
    // Fecha SQL
   if (TYPEEDIT === 12) return formatSQLDate(value, "date");
    else if (TYPEEDIT === 10) return formatSQLDate(value, "time", false); // sin segundos
     else if (TYPEEDIT === 13) return formatSQLDate(value, "time",true);
     return formatSQLDate(value, "auto");
  } else if (TYPE === 13) {
    // Fecha SAP
    return ctod(value);
  }

  return value;
}

/**
 * Convierte un valor de fecha editable de vuelta al formato del campo
 * @param {any} value - Valor en DD/MM/YYYY
 * @param {object} field - { Type, TypeEdit }
 * @returns {string} Valor convertido a SAP o SQL
 */
export function saveDate(value, field) {
  if (!value) return "";
  const { TYPE, TYPEEDIT } = field;

  if (TYPEEDIT !== 4 && TYPEEDIT !== 12) return value; // solo campos de edición de fecha

  if (TYPE === 2) {
    // Fecha SQL
    // Dependiendo si quieres ISO (YYYY-MM-DD) o YYYYMMDD
    return dtoc(value);
  } else if (TYPE === 13) {
    // Fecha SAP
    return dtoc(value);
  }

  return value;
}
